// 一键编辑弹窗
import fetchModifyUserInfo from '@/apis/user';
import { Avatar, Modal, Form, Input, Radio, message } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { fetchMyProfile } from '@/apis/account';
import { fetchUserInfo } from '@/apis/user';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormOutlined, UserOutlined } from '@ant-design/icons';
import DialogHeading from '@/components/dialogheading';
import ImagePicker from '@/components/imagepicker';
import { uploadAvatar } from '@/apis/uploads';
import { setUserInfo } from '@/store/modules/user';
import usePrivateAction from '@/utils/usePrivateAction';
import authSession from '@/utils/authSession';
import { getRequestErrorMessage } from '@/utils/requestError';
import './ProfileEditors.scss';

const EditAllModal = ({ allOpen, setAllOpen }) => {
  // 配置初始化
  const dispatch = useDispatch();
  const [allForm] = Form.useForm();
  const { busy: submitting, run } = usePrivateAction();
  const [files, setFiles] = useState([]);
  const active = useRef(false);
  const { userInfo } = useSelector(state => state.user);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    active.current = allOpen;
    return () => { active.current = false; };
  }, [allOpen]);
  useEffect(() => {
    if (!allOpen) return;
    let current = true; setLoading(true); setProfile(null); setFiles([]);
    fetchMyProfile().then(data => { if (current) { setProfile(data); allForm.setFieldsValue({ nickname: data.nickname || '', gender: data.gender || '' }); } })
      .catch(() => { if (current) message.error('资料加载失败，请重新打开编辑窗口'); }).finally(() => { if (current) setLoading(false); });
    return () => { current = false; };
  }, [allOpen, allForm]);
  // 用户点击确认后处理修改请求
  const onAllCreate = async (values) => {
    if (submitting || loading || !profile) return;
    const generation = authSession.getGeneration();
    const current = () => active.current && generation === authSession.getGeneration();
    let avatarUpdated = false;
    return run(async () => {
      if (files.length) {
        const uploaded = await uploadAvatar(files[0].originFileObj || files[0]);
        if (!current()) return;
        if (!uploaded?.avatar || !uploaded.user?.id) throw new Error('头像上传响应无效');
        dispatch(setUserInfo(uploaded.user));
        setProfile(uploaded.user);
        setFiles([]);
        avatarUpdated = true;
      }
      // 头像由专用上传接口更新，不再将旧头像链接写回个人资料。
      const { nickname, gender } = values;
      const result = await fetchModifyUserInfo({ nickname, gender }, userInfo.username);
      if (!result?.success) throw new Error(result?.error || '资料修改失败');
    }, async () => {
      if (!current()) return;
      await dispatch(fetchUserInfo());
      if (!current()) return;
      setAllOpen(false);
      message.success('资料修改成功');
    }, error => `${avatarUpdated ? '头像已更新，其他资料保存失败：' : ''}${getRequestErrorMessage(error, error.message || '资料修改失败')}`);
  };
  const close = () => { if (!submitting) { setFiles([]); setAllOpen(false); } };
  return (
    <Modal
      open={allOpen}
      className="profileEditor-modal"
      centered
      width={520}
      title={<DialogHeading icon={<FormOutlined />} title="编辑资料" description="完善个人信息，让伙伴更了解你" />}
      okText="保存资料"
      cancelText="取消"
      okButtonProps={{ autoFocus: true, htmlType: 'submit', loading: submitting || loading, disabled: !profile || submitting || loading }}
      cancelButtonProps={{ disabled: submitting }}
      closable={!submitting}
      keyboard={!submitting}
      mask={{ closable: !submitting }}
      onCancel={close}
      destroyOnHidden
      modalRender={dom => (
        <Form
          layout="vertical"
          form={allForm}
          name="all_form_in_modal"
          aria-label="编辑个人资料"
          disabled={loading || submitting}
          // 默认为用户原本信息，没有则置空
          initialValues={{ nickname: userInfo?.nickname || '', gender: userInfo?.gender || '' }}
          clearOnDestroy
          onFinish={values => onAllCreate(values)}
        >
          {dom}
        </Form>
      )}
    >
      {/* 昵称输入框 */}
      <Form.Item
        name="nickname"
        label="昵称"
      >
        <Input maxLength={12} placeholder="输入你的昵称" showCount />
      </Form.Item>
      <Form.Item label="头像">
        <div className="profileEditor-avatar"><Avatar size={64} src={profile?.avatar || userInfo?.avatar || undefined} icon={<UserOutlined />} /><div><strong>当前头像</strong><p>不选择新图片，将保留原头像</p></div></div>
        <ImagePicker files={files} onChange={setFiles} maxCount={1} maxMiB={5} disabled={loading || submitting} />
      </Form.Item>
      {/* 性别选择框 */}
      <Form.Item label="邮箱"><div className="profileEditor-linkedSetting"><span>{profile?.email || '尚未绑定'}</span><Link to="/personal/email" aria-disabled={submitting} onClick={event => { if (submitting) event.preventDefault(); else close(); }}>邮箱设置</Link></div></Form.Item>
      <Form.Item name="gender" label="性别">
        <Radio.Group className="profileEditor-genderOptions">
          <Radio.Button value="M">男</Radio.Button>
          <Radio.Button value="F">女</Radio.Button>
          <Radio.Button value="">不愿透露</Radio.Button>
        </Radio.Group>
      </Form.Item>
    </Modal>
  );
};

export default EditAllModal;
